import axiosInstance from "global/helpers/axiosInstance";
import {
  ORDENDIGITAL_SUCCESS,
  ORDENDIGITAL_LOADING,
  ORDENDIGITAL_ERROR,
  ORDENDIGITALGRUPO_SUCCESS,
  ORDENDIGITAL_RESET,
  ORDENDIGITAL_ALTATURNO_SET,
  ORDENDIGITAL_SOLICITANTE_SET,
  ORDENDIGITAL_LOAD,
  ORDENDIGITAL_FLGVOLVER,
  ORDENDIGITALPDF_SUCCESS,
  ORDENDIGITALPDF_LOADING,
  ORDENDIGITALPDF_ERROR,
  ORDENDIGITALPDF_RESET,
} from "../../ActionTypes";

export const wsGetOrdenDigitalEstudio = (nextStep) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/GetByIDPACIENTEQr`)
      .then((res) => {
        dispatch({
          type: ORDENDIGITAL_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err.response?.data);
      });
  });
};

export const wsGetGrupoByIdOrden = (id, nextStep) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/items/${id}`)
      .then((res) => {
        dispatch({
          type: ORDENDIGITALGRUPO_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error);
      });
  });
};

export const wsGetPDFOrdenEstudio = (id, nextStep) => (dispatch) => {
  dispatch({ type: ORDENDIGITALPDF_LOADING });
  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/OrdenDigital/GetPDF/${id}`)
      .then((resp) => {
        dispatch({
          type: ORDENDIGITALPDF_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: ORDENDIGITALPDF_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};

export const resetPDFOrdenEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENDIGITALPDF_RESET,
  });
};

export const setLoadingOrdenDigitalEstudio = (loading) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOAD,
    payload: loading,
  });
};

export const setAltaOrdenDigitalEstudio = (ordenDigital) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_ALTATURNO_SET,
    payload: ordenDigital,
  });
};

export const setMedicoSolicitante = (idMedico) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_SOLICITANTE_SET,
    payload: idMedico,
  });
};

export const setFlgVolverOrdenDigitalEstudio = (flgVolver) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_FLGVOLVER,
    payload: flgVolver,
  });
};

export const resetOrdenDigitalEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_RESET,
  });
};
